// Минимальный разбор CMS (PKCS#7 SignedData) для извлечения подписанного содержимого.
// Подписи/сертификаты не разбираются — нужен только eContent из encapContentInfo.

const TAG_OCTET_STRING = 0x04
const TAG_OCTET_STRING_CONSTRUCTED = 0x24
const TAG_CONTEXT_0 = 0xA0

function base64ToBytes (base64) {
  const cleanBase64 = base64.includes(',') ? base64.split(',')[1] : base64
  const binary = atob(cleanBase64.replace(/\s/g, ''))
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return bytes
}

// Читает один TLV-узел, начиная с pos. Поддерживает и DER, и BER с неопределённой длиной.
function readNode (bytes, pos) {
  const tag = bytes[pos]
  const constructed = (tag & 0x20) !== 0
  let offset = pos + 1
  const first = bytes[offset++]
  if (first === 0x80) {
    const start = offset
    let cursor = start
    while (!(bytes[cursor] === 0x00 && bytes[cursor + 1] === 0x00)) {
      cursor = readNode(bytes, cursor).next
    }
    return { tag, constructed, start, end: cursor, next: cursor + 2 }
  }
  let length = first
  if (first & 0x80) {
    const count = first & 0x7F
    length = 0
    for (let i = 0; i < count; i++) {
      length = length * 256 + bytes[offset++]
    }
  }
  if (offset + length > bytes.length) {
    throw new Error('Некорректная структура CMS')
  }
  return { tag, constructed, start: offset, end: offset + length, next: offset + length }
}

function children (bytes, node) {
  const result = []
  let cursor = node.start
  while (cursor < node.end) {
    const child = readNode(bytes, cursor)
    result.push(child)
    cursor = child.next
  }
  return result
}

function readOctetString (bytes, node) {
  if (node.tag === TAG_OCTET_STRING) {
    return bytes.slice(node.start, node.end)
  }
  if (node.tag === TAG_OCTET_STRING_CONSTRUCTED) {
    const parts = children(bytes, node).map(child => readOctetString(bytes, child))
    const total = parts.reduce((sum, part) => sum + part.length, 0)
    const result = new Uint8Array(total)
    let offset = 0
    parts.forEach(part => {
      result.set(part, offset)
      offset += part.length
    })
    return result
  }
  throw new Error('Неожиданный тип содержимого CMS')
}

// ContentInfo ::= SEQUENCE { contentType, [0] SignedData }
// SignedData ::= SEQUENCE { version, digestAlgorithms, encapContentInfo, ... }
// EncapsulatedContentInfo ::= SEQUENCE { eContentType, [0] eContent OCTET STRING OPTIONAL }
function extractCmsContent (cmsBase64) {
  const bytes = base64ToBytes(cmsBase64)
  const contentInfo = readNode(bytes, 0)
  const explicitSignedData = children(bytes, contentInfo)[1]
  if (!explicitSignedData || explicitSignedData.tag !== TAG_CONTEXT_0) {
    throw new Error('CMS не содержит SignedData')
  }
  const signedData = children(bytes, explicitSignedData)[0]
  const encapContentInfo = children(bytes, signedData)[2]
  const explicitContent = encapContentInfo ? children(bytes, encapContentInfo)[1] : null
  if (!explicitContent || explicitContent.tag !== TAG_CONTEXT_0) {
    throw new Error('Подпись отсоединённая — исходный файл в CMS отсутствует')
  }
  return readOctetString(bytes, children(bytes, explicitContent)[0])
}

function isZip (bytes) {
  return bytes.length > 3 && bytes[0] === 0x50 && bytes[1] === 0x4B
}

// Возвращает байты исходного xlsx. Если подписывался base64-текст, а не сами байты, декодирует его.
function extractCmsXlsx (cmsBase64) {
  const content = extractCmsContent(cmsBase64)
  if (isZip(content)) {
    return content
  }
  try {
    const decoded = base64ToBytes(new TextDecoder().decode(content))
    if (isZip(decoded)) {
      return decoded
    }
  } catch (e) {
    // содержимое не base64 — значит это не xlsx
  }
  throw new Error('Содержимое CMS не является Excel-файлом')
}

export { extractCmsContent, extractCmsXlsx }
